"use strict";
var _ = require("lodash");
function getHighlighted(entity, highlightedNodes) {
    var result = {
        highlighted: false,
        color: null
    };
    // Only allow nodes and edges to be highlighted
    if ((entity.kaavioType != 'Node') && (entity.kaavioType != 'Edge'))
        return result;
    var matched = _.find(highlightedNodes, function (value, index) {
        return value['node_id'] == entity.id;
    });
    if (matched) {
        result.highlighted = true;
        result.color = matched.color;
    }
    return result;
}
exports.getHighlighted = getHighlighted;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0SGlnaGxpZ2h0ZWQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvS2FhdmlvL3V0aWxzL2dldEhpZ2hsaWdodGVkLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSwwQkFBNEI7QUFHNUIsd0JBQStCLE1BQU0sRUFBRSxnQkFBZ0I7SUFDbkQsSUFBSSxNQUFNLEdBQUc7UUFDVCxXQUFXLEVBQUUsS0FBSztRQUNsQixLQUFLLEVBQUUsSUFBSTtLQUNkLENBQUM7SUFFRiwrQ0FBK0M7SUFDL0MsRUFBRSxDQUFBLENBQUMsQ0FBQyxNQUFNLENBQUMsVUFBVSxJQUFJLE1BQU0sQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLFVBQVUsSUFBSSxNQUFNLENBQUMsQ0FBQztRQUFDLE1BQU0sQ0FBQyxNQUFNLENBQUM7SUFFakYsSUFBSSxPQUFPLEdBQW9CLENBQUMsQ0FBQyxJQUFJLENBQUMsZ0JBQWdCLEVBQUUsVUFBQyxLQUFLLEVBQUUsS0FBSztRQUNqRSxNQUFNLENBQUMsS0FBSyxDQUFDLFNBQVMsQ0FBQyxJQUFJLE1BQU0sQ0FBQyxFQUFFLENBQUM7SUFDekMsQ0FBQyxDQUFvQixDQUFDO0lBRXRCLEVBQUUsQ0FBQyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUM7UUFDVixNQUFNLENBQUMsV0FBVyxHQUFHLElBQUksQ0FBQztRQUMxQixNQUFNLENBQUMsS0FBSyxHQUFHLE9BQU8sQ0FBQyxLQUFLLENBQUM7SUFDakMsQ0FBQztJQUVELE1BQU0sQ0FBQyxNQUFNLENBQUM7QUFDbEIsQ0FBQztBQW5CRCx3Q0FtQkMifQ==


//////////////////
// WEBPACK FOOTER
// ./~/@wikipathways/pvjs/lib/Kaavio/utils/getHighlighted.js
// module id = 177
// module chunks = 0